import { InputDate } from "./input-date";
export class OralDate {
    constructor(enrollmentDate) {
        this.enrollmentDate = enrollmentDate;
        this.start = new InputDate($("#oral_start"));
        this.end = new InputDate($("#oral_end"));
    }
    check() {
        if (this.start.empty || this.end.empty || !this.isChanged) {
            return;
        }
        if (this.start.getDaysDifference(this.enrollmentDate) <= 0) {
            throw new Error(incorrectOralInitial);
        }
        if (this.end.getDaysDifference(this.start) < 0) {
            throw new Error(incorrectOralFinal);
        }
    }
    get isChanged() {
        return this.start.isChanged || this.end.isChanged;
    }
}
